<template>
<el-dialog :visible.sync="dialogVisible" top="0" width="565px" :before-close="closeModal">
    <RotateWithCircle class="d-flex mt-5 mb-2 mx-auto" :colorCircle="getPrimaryColorHex.two" :color="getPrimaryColorHex.four" />
    <h3 class="c-ndarkthree bold text-center mb-2">
        Atualizar Documento
    </h3>
    <p class="c-ndarkfour regular text-center">
        Atualize o documento cadastrado pelo cedente
    </p>
    <div class="mt-4 mb-4 d-flex flex-column align-items-center">
        <label class="w-75">Documento</label>
        <el-select  
            :popper-class="getPrimaryColor"
            class="w-75"    
            placeholder="Selecionar documento"
            v-model="documentType"
        >
            <el-option
                v-for="document in documentsList"
                :label="document.title"
                :key="document.type"
                :value="document.type"
            >
            </el-option>
        </el-select>
    </div>
    
    <span slot="footer" class="dialog-footer d-flex justify-content-end align-items-center">
        <router-link to="" @click.native="closeModal"  :class="`${getPrimaryColor} mr-4 pointer`">
            <p class="c-ndarkfour">
                Cancelar
            </p>
        </router-link>
        <button :class="`btn btn-${getPrimaryColor}`" :disabled="!this.documentType" @click="updateDocumentType">
            Atualizar
        </button>
    </span>
</el-dialog>
</template>

<script>
import RotateWithCircle from '@/components/icons/RotateWithCircle'

export default {
    components: {
        RotateWithCircle
    },
    props: {
        dialogVisible: {
            required: true,
            type: Boolean,
            default: false
        },
        documentsList: {
            required: true,
            type: Array,
        }
    },
    data() {
        return {
            documentType: '',
        }
    },
    methods: {
        closeModal() {
            this.documentType = ''

            this.$emit('closeModal', false)
        },
        updateDocumentType() {
            this.$emit('updateDocumentType', this.documentType)
            this.closeModal()
        }
    },
}
</script>

<style>
</style>